import { Fragment } from 'react/jsx-runtime'
import { AddonResultDetails, ListResult } from '../list-view/list-view'
import { NumberSelectionSummary } from '../number-selection-summary/number-selection-summary'

export type ReceiptBreakdownNumberSummaryProps = {
  className: string
  kenoResult: ListResult
  addonDetails: AddonResultDetails[]
}

export const ReceiptBreakdownNumberSummary = ({
  addonDetails,
  className,
  kenoResult,
}: ReceiptBreakdownNumberSummaryProps) => {
  return (
    <div className={`${className}__receipt-breakdown__section__number-selections-container`}>
      <NumberSelectionSummary
        addOnDetails={addonDetails}
        numbersPerRow={5}
        numberSelections={kenoResult.numberSelections || []}
      />
      {addonDetails.length ? (
        <div
          className={`${className}__receipt-breakdown__section__number-selections-container__addon-legend`}>
          {addonDetails.map((ad) => {
            return (
              <Fragment key={ad.name}>
                <div
                  className="ticket-form-summary__addon-legend-color"
                  style={ad.color ? { backgroundColor: ad.color } : {}}></div>
                <div>{ad.name}</div>
              </Fragment>
            )
          })}
        </div>
      ) : null}
    </div>
  )
}
